<template>
  <div class="headerStarAssignment">
    <h1>{{ $t('starAssignment.label.title') }}</h1>
    <div class="assign">
      <v-select class="custom-select" outlined :label="'*'+$t('starAssignment.label.star.title')" :placeholder="$t('starAssignment.label.star.text')" 
        required :rules="starRules" color="secondary" :items="typeStartList" item-text="nameStar" 
        item-value="starId" v-model="formData.assignTypeStar"></v-select>
    </div>
    <div v-if="formData.assignTypeStar == '1'">
      <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center">
        <div class="assign col-md-4 col-sm-12">
          <v-select class="custom-select" outlined :label="'*'+$t('starAssignment.label.assign.title')" :placeholder="$t('starAssignment.label.assign.text')" 
            :items="typeAssign" item-text="assignTypeName" item-value="assignTypeId" v-model="formData.assignTypeName" color="secondary"></v-select>
        </div>
        <div class="assign col-md-4 col-sm-12">
          <v-select class="custom-select" outlined :label="'*'+$t('starAssignment.label.typeStar.title')" :placeholder="$t('starAssignment.label.typeStar.text')"
            :items="typeStar" item-text="name" item-value="id" v-model="formData.shapeTypeId" color="secondary"></v-select>
        </div>
        <div class="assign col-md-4 col-sm-12">
          <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" color="secondary"
            offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="formattedRedeemDate" :label="'*'+$t('starAssignment.label.dateMonetization')" color="secondary" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="localRedeemDate" color="primary" @change="handleDateChange"></v-date-picker>
          </v-menu>
        </div>
      </div>
      <template v-if="formData.assignTypeName == 45 || formData.assignTypeName == 1">
        <v-row no-gutters class="mb-5">
          <v-col md="3" sm="6" class="pa-2" v-for="(item, i) in getIndividualCategorizedCards" :key="i">
            <v-card :class="item.isGrayedOut ? 'cardStyle-gray' : 'cardStyle'">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title style="font-size: 1.10rem; word-break: auto-phrase;">{{ item.categoryName }}</v-card-title>
                  <v-card-title class="text-h5">{{ item.shapeCount }}</v-card-title>
                </div>
                <v-avatar class="avatarStyle" size="60">
                  <div class="icon-item">
                    <img :src="item.icon" />
                  </div>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <assignstarIndividual :shapeTypeId="this.formData.shapeTypeId" :redeemDate="this.formData.redeemDate" />
      </template>
      <template v-if="formData.assignTypeName == 46 || formData.assignTypeName == 2">
        <v-row no-gutters class="mb-5">
          <v-col md="3" sm="6" class="pa-2" v-for="(item, i) in categorizedCards" :key="i">
            <v-card :class="item.isGrayedOut ? 'cardStyle-gray' : 'cardStyle'">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title style="font-size: 1.10rem; word-break: auto-phrase;">{{ item.categoryName }}</v-card-title>
                  <v-card-title class="text-h5">{{ item.shapeCount }}</v-card-title>
                </div>
                <v-avatar class="avatarStyle" size="60">
                  <div class="icon-item">
                    <img :src="item.icon" />
                  </div>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <assignstarAll :typeCategory="this.typeCategory.listRecognitionCategoryParameters"
          :affiliatesCount="this.typeCategory.affiliateCount"
          :maxRecognitionCount="this.typeCategory.maxRecognitionCount" :shapeTypeId="this.formData.shapeTypeId"
          :redeemDate="this.formData.redeemDate" />
      </template>
      <template v-if="formData.assignTypeName == 47 || formData.assignTypeName == 3">
        <assignmetTemplate :dialogStart="true" />
      </template>
    </div>
    <div v-if="formData.assignTypeStar == '2'">
      <starZen></starZen>
    </div>
  </div>
</template>

<script>
  import assignstarIndividual from "@/views/star_assignment/pages/star_assignment/components/form_assignment_individual_component.vue";
  import assignmetTemplate from "@/views/star_assignment/pages/star_assignment/components/form_assignment_template_component.vue";
  import assignstarAll from "@/views/star_assignment/pages/star_assignment/components/form_assignment_all_component.vue";
  import starZen from "@/views/star_assignment/pages/star_assignment/components/form_assignment_star_zen_component.vue";
  import {
    ACTION_GET_CARDS,
    RECOGNITION_BUYING_M,
    GET_CARDS,
  } from "@/views/recognition/store/types/types.js";

  import {
    STARASSIGNMENT_M,
    GET_LIST_TYPE_STAR_LIST,
    ACTION_GET_TYPE_STAR_LIST,
    ACTION_GET_STARASSIGNMENT_LIST,
    GET_STARASSIGNMENT_LIST,
    ACTION_GET_STARTYPE_LIST,
    GET_STARTYPES_LIST,
    GET_STARASSIGNMENT_TYPE_CATEGORY,
    GET_CARDSLIST,
  } from "@/views/star_assignment/store/types/types.js";

  import { mapActions, mapGetters } from "vuex";
  import i18n from '@/plugins/i18n';
  import Swal from "sweetalert2";

export default {
  name: "mainStarAssignmentComponent",
  components: {
    assignstarAll,
    assignstarIndividual,
    assignmetTemplate,
    starZen
  },
  data() {
    return {
      dialog: false,
      menu: false,
      localRedeemDate: null,
      formattedRedeemDate: "",
      formData: {},
      typeIdentificationData: [],
      categories: [],
      destinationUsers: [],
      starRules: [
        v => !!v || this.$t('starAssignment.label.star.required')
      ],
    };
  },

  async mounted() {
    await this.getActiontypeStartList();
    await this.getActionTypeAssign();
    await this.getActionTypeStart();
    await this.getCards();
    this.verificateWhiteStar();
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      window.location.reload();
    },

    ...mapActions({
      getActiontypeStartList: `${STARASSIGNMENT_M}${ACTION_GET_TYPE_STAR_LIST}`,
      getActionTypeAssign: `${STARASSIGNMENT_M}${ACTION_GET_STARASSIGNMENT_LIST}`,
      getActionTypeStart: `${STARASSIGNMENT_M}${ACTION_GET_STARTYPE_LIST}`,
      getCards: `${RECOGNITION_BUYING_M}${ACTION_GET_CARDS}`,
    }),

    handleDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);

      if (isNaN(selectedDate)) {
        console.error("Invalid date object:", date);
        return;
      }

      this.localRedeemDate = date;

      const modifiedDate = new Date(selectedDate);

      this.formData.redeemDate = new Date(selectedDate)
        .toISOString()
        .split("T")[0];

      this.formattedRedeemDate = date;

      this.validateDate(modifiedDate);

      this.menu = false;
    },

    validateDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const selectedDate = new Date(modifiedDate);
      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + 90);

      if (selectedDate < today) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text1')
        });
        this.localRedeemDate = null;
        this.formattedRedeemDate = "";
        this.formData.redeemDate = null;
        return;
      }

      if (selectedDate > maxDate) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text2')
        });
        this.localRedeemDate = null;
        this.formattedRedeemDate = "";
        this.formData.redeemDate = null;
      }
    },

    verificateWhiteStar() {
      // Marcar las tarjetas que deben ocultarse
      this.cards.forEach((card) => {
        // Si la tarjeta tiene "White" en el nombre y shapeCount es 0, marcar para ocultar
        if (card.categoryName.includes('White') && card.shapeCount === 0) {
          card.shouldHide = true;
        } else {
          card.shouldHide = false;
        }
      });
    },
  },

  computed: {
    ...mapGetters({
      cards: `${RECOGNITION_BUYING_M}${GET_CARDS}`,
      cardsList: `${STARASSIGNMENT_M}${GET_CARDSLIST}`,
      typeAssign: [`${STARASSIGNMENT_M}${GET_STARASSIGNMENT_LIST}`],
      typeStartList: [`${STARASSIGNMENT_M}${GET_LIST_TYPE_STAR_LIST}`],
      typeStar: [`${STARASSIGNMENT_M}${GET_STARTYPES_LIST}`],
      typeCategory: [`${STARASSIGNMENT_M}${GET_STARASSIGNMENT_TYPE_CATEGORY}`],
    }),

    categorizedCards() {
      const affiliatesCount = Number(this.typeCategory.affiliateCount);
      return this.cards.map((card) => {
        card.isGrayedOut = card.shapeCount < affiliatesCount;
        return card;
      });
    },

    getIndividualCategorizedCards() {
      // Primero filtrar las tarjetas que no deben ocultarse
      const visibleCards = this.cards.filter((card) => !card.shouldHide);
      
      return visibleCards.map((card) => {
        const cardInCardsList = this.cardsList.find(
          (cardListItem) => cardListItem.categoryName === card.categoryName
        );
        if (!cardInCardsList) {
          return {
            ...card,
            isGrayedOut: true,
          };
        }
        return {
          ...card,
          isGrayedOut: false,
        };
      });
    },
  },
};
</script>

<style lang="css" scoped>
.headerStarAssignment {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(110, 23, 165, 0.08);
  margin: 20px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

h1 {
  font-size: 2rem;
  margin: 0;
}

.assign {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 320px;
  padding: 8px 16px;
}

.avatarStyle {
  background-color: white !important;
}

.icon-item {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cardStyle {
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(110, 23, 165, 0.1) !important;
  border: 1px solid #f2b37b;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cardStyle-gray {
  border-radius: 16px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  color: #888;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cardStyle .v-card-title,
.cardStyle-gray .v-card-title {
  padding: 8px 16px;
}

.custom-font {
  font-size: 20px;
}

.inputCantidad {
  text-align: center;
  color: #2d0049;
  border: 2px solid;
  border-radius: 10px;
  border-color: #6e17a5;
  background-color: #eadcf3;
}

.inputCantidad-disabled {
  color: #888;
  background-color: #f0f0f0;
  border-color: #ccc;
}

.subtotal {
  text-align: right;
  color: #6e17a5;
  padding: 0 60px;
  font-size: 23px;
  font-weight: 500;
}

.disabled-btn {
  background-color: #ccc !important;
  color: #fff !important;
}

.container {
  position: relative;
}

.v-btn.fixed {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

@media screen and (max-width: 600px) {
  .headerStarAssignment {
    margin: 12px;
    padding: 16px;
  }

  h1 {
    font-size: 1.5rem;
  }

  .assign {
    max-width: 100%;
    padding: 8px 0;
  }

  .cardStyle,
  .cardStyle-gray {
    min-height: 100px;
  }
}

/* Ajusta este valor para cambiar el redondeo de los selects */
.custom-select >>> .v-input__slot {
  border-radius: 10px !important;
}

</style>
